<form
  class="space-y-3"
  [formGroup]="form">
  <div class="bg-bg-surface-default space-y-5 rounded-xl p-8">
    <div class="pb-2">
      <h1 class="text-text-default text-lg font-bold">Kontak Pribadi</h1>
      <p class="text-text-subtler text-sm">
        Digunakan untuk komunikasi langsung dengan karyawan.
      </p>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">No. Telepon / WA</p>
        </div>
        <p class="text-text-subtler text-xs">
          Bisa di skip sman jangan lupa minta fotoin Ganang untuk karyawan baru ini
        </p>
      </div>
      <div class="col-span-2">
        <div class="flex gap-2">
          <div class="w-32 space-y-1">
            <app-input-phone-ext
              class="block"
              formControlName="phone_ext"
              (ngModelChange)="formService.resetError(formError, 'phone_ext')" />
            @if (formError.phone_ext.msg) {
              <p class="text-text-error text-xs">{{ formError.phone_ext.msg }}</p>
            }
          </div>
          <div class="grow space-y-1">
            <app-input-number
              class="block"
              formControlName="phone"
              placeholder="Ketik No. Telepon"
              [maxlength]="13"
              [useGrouping]="false"
              (ngModelChange)="formService.resetError(formError, 'phone')" />
            @if (formError.phone.msg) {
              <p class="text-text-error text-xs">{{ formError.phone.msg }}</p>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Email</p>
          <!--
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
          -->
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="email"
            placeholder="Ketik Email"
            [disabled]="isEdit"
            (ngModelChange)="formService.resetError(formError, 'email')" />
          @if (formError.email.msg) {
            <p class="text-text-error text-xs">{{ formError.email.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">URL Instagram</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="instagram_url"
            placeholder="Ketik URL Instagram"
            (ngModelChange)="formService.resetError(formError, 'instagram_url')" />
          @if (formError.instagram_url.msg) {
            <p class="text-text-error text-xs">{{ formError.instagram_url.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">URL Facebook</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="facebook_url"
            placeholder="Ketik URL Facebook"
            (ngModelChange)="formService.resetError(formError, 'facebook_url')" />
          @if (formError.facebook_url.msg) {
            <p class="text-text-error text-xs">{{ formError.facebook_url.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">URL Tiktok</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="tiktok_url"
            placeholder="Ketik URL Tiktok"
            (ngModelChange)="formService.resetError(formError, 'tiktok_url')" />
          @if (formError.tiktok_url.msg) {
            <p class="text-text-error text-xs">{{ formError.tiktok_url.msg }}</p>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="flex items-center justify-between gap-3">
    <app-button
      theme="outline"
      class="block w-32"
      styleClass="bg-bg-surface-default"
      (click)="back.emit()">
      Kembali
    </app-button>
    <app-button
      class="ml-auto block w-32"
      (click)="_next()">
      Selanjutnya
    </app-button>
  </div>
</form>
